document.addEventListener("DOMContentLoaded", function () {
  const menuButton = document.querySelector("#ce-icon-menu-mobile");
  const header = document.querySelector("#ce-menu-movil");
  const account = document.querySelector(".cart.nav-account");
  const ticker = document.querySelector(".ticker-s24");
  const searchIcon = document.querySelector(".cart.nav-search.buscador");
  const svgs = document.querySelectorAll(".site-control .site-control__inner svg");
  const coloricon = document.querySelectorAll(".site-control.nav-inline-desktop .cart")
  const basketNumber = document.querySelector(".cart-svg--container > div");
  const logoAlt = document.querySelector(".logo .alt-logo");
  const logo = document.querySelector(".logo > img");
  const bars = document.querySelectorAll(".icon-menu__bar");
  const menuDesktopOrder = document.querySelector(".MenuDesktop__Order");
  const navLeftMenu = document.querySelector(".nav-left--menu");
  const borderHeader = document.querySelector(".Header__BorderBottom");
  const heroSection = document.querySelector(
    ".hero-section-s24.scroll-section"
  );
  const navSearchSvg = document.querySelector(
    ".site-control .site-control__inner .nav-search svg"
  );
  
  const modalOverlay = document.querySelector("#search-modal .modal-close-overlay");
  const modalClose  = document.querySelector("#search-modal .modal-close");
  const searchInput = document.querySelector("#search-modal .search-form .inline-mini-form input");
  const navBody = document.querySelector(".nav-body nav");
  const suggestionWords = document.querySelectorAll(".suggestion-words .suggestion");
  const suggestions = document.querySelector(".suggestions");

  let isSearchOpen = false; // Variable global para controlar si el buscador está abierto
  let openedFrom = ""; 
  let openedFromBuscadorDesktop = false;

  // Función para verificar si la sección S24 es visible en el viewport
  function isHeroSectionVisible() {
    if (!heroSection) return false;
    const rect = heroSection.getBoundingClientRect();
    return rect.top >= 0 && rect.bottom > 0; // Sección visible en el viewport
  }

  // Función para eliminar transiciones y evitar parpadeos
  function removeTransitions() {
    svgs.forEach((svg) => (svg.style.transition = "none"));
    bars.forEach((bar) => (bar.style.transition = "none"));
    if (searchIcon) searchIcon.style.transition = "none";
    if (account) account.style.transition = "none";
    if (logoAlt) logoAlt.style.transition = "none";
    if (header) header.style.transition = "none";
  }

  // Función para aplicar estilos cuando el menú está abierto
  function applyStyles() {
    removeTransitions();
    svgs.forEach((svg) => (svg.style.fill = "white"));
    bars.forEach((bar) => (bar.style.backgroundColor = "white"));
    coloricon.forEach((icon) => (icon.style.color = "white"));
    if (searchIcon) searchIcon.style.display = "none";
    if (basketNumber) basketNumber.style.color = "white";
    if (account) account.style.color = "white";
    if (logoAlt) logoAlt.style.opacity = 1;
    if (logo) logo.style.opacity = 0;
    if (ticker) ticker.style.display = "none";
    if (modalOverlay) modalOverlay.style.display = "none";
    if (modalClose) modalClose.style.display = "none";
    if (navBody) navBody.style.display = "block";
    borderHeader.style.borderBottom = "0px";
  }

  // Función para restaurar los estilos originales cuando el menú se cierra
  function resetStyles() {
    removeTransitions();
    if (isHeroSectionVisible() && window.scrollY === 0) {
      // Caso especial: Estamos en la sección Home S24 y en la parte superior de la página
      svgs.forEach((svg) => (svg.style.fill = "white"));
      bars.forEach((bar) => (bar.style.backgroundColor = "white"));
          coloricon.forEach((icon) => (icon.style.color = "white"));

      if (account) account.style.color = "white";
      if (logoAlt) logoAlt.style.opacity = 1;
      if (logo) logo.style.opacity = 0;
      if (ticker) ticker.style.display = "block";
      if (basketNumber) basketNumber.style.color = "white";
    } else {
      borderHeader.style.borderBottom = "1px solid #C4C4C4";
      // Caso normal: Estamos fuera del top o en otra sección
      svgs.forEach((svg) => (svg.style.fill = "black"));
      bars.forEach((bar) => (bar.style.backgroundColor = "black"));
          coloricon.forEach((icon) => (icon.style.color = "black"));

      if (account) account.style.color = "";
      if (logoAlt) logoAlt.style.opacity = 0;
      if (logo) logo.style.opacity = 1;
      if (ticker) ticker.style.display = "none";
      if (basketNumber) basketNumber.style.color = "black";
    }
    if (searchIcon) searchIcon.style.display = "";
    if (modalOverlay) modalOverlay.style.display = "block";
    if (modalClose) modalClose.style.display = "block";


    if (!isSearchOpen) {
      navSearchSvg.style.display = "block";
    }
  }
  const buscadorDesktop = document.querySelector(".buscador-desktop");
  document.addEventListener("keydown", function(event) {
    if ((event.key === "Escape" || event.keyCode === 27)) {
      const header = document.querySelector("#ce-menu-movil");
      const menuButton = document.querySelector("#ce-icon-menu-mobile");
  
      if (header && header.classList.contains("menu-open") && menuButton) {
        console.log("Escape detectado con menú abierto, cerrando con click en menú.");
        event.preventDefault();
        event.stopImmediatePropagation();
        menuButton.click(); // 🔵 Simula click en el botón para cerrar
      }
    }
  }, true); // importante usar capture: true
  
  
  if (buscadorDesktop) {
    buscadorDesktop.addEventListener("click", function (e) {
     
      e.preventDefault();
  
      const isMenuOpen = header.classList.contains("menu-open");
      console.log("estoy abierto?");
      console.log(isMenuOpen)
      if (isMenuOpen && openedFrom === "search") {
        // 👈 Si está abierto y venimos de "search" ➔ CERRAR
        if (modalClose) modalClose.click();
       
        menuDesktopOrder.classList.add("no-hover-temporal");
        setTimeout(() => {
          menuDesktopOrder.classList.remove("no-hover-temporal");
        }, 2000);
        if (menuDesktopOrder) menuDesktopOrder.style.visibility = "visible"; // 🔵 Volvemos a mostrar el menú desktop
        if (navLeftMenu) navLeftMenu.style.display = "none"; // 🔵 Mostrar de nuevo con display block

        if (document.body.classList.contains("template-index")) {
          logoAlt.style.display = "block";
          logoAlt.style.opacity = "1";
          logo.style.opacity = "1";
          logo.style.display = "none";
        }
        else{
          
          logoAlt.style.display = "none";
          logo.style.opacity = "1";
          logo.style.display = "block";
        }
        
        menuButton.click();
        openedFrom = "";
      } else {
       logoAlt.style.display = "block";
       logoAlt.style.opacity = "1";
        logo.style.opacity = "0";
        //logo.style.display = "none";
        // 👈 Si no está abierto ➔ ABRIR
        openedFrom = "search";
        openedFromBuscadorDesktop = true;
  
        menuButton.click();
  
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            if (searchInput) {
              searchInput.focus();
              searchInput.scrollIntoView({ behavior: "smooth", block: "center" });
            }
            if (menuDesktopOrder) menuDesktopOrder.style.visibility = "hidden"; // 🔵 Ocultar menú desktop
            if (navLeftMenu) navLeftMenu.style.display = "block"; // 🔵 Mostrar de nuevo con display block

          });
        });
      }
    });
  }
  if (searchIcon) {
    searchIcon.addEventListener("click", function (event) {
      openedFrom = "search";
      event.preventDefault();
  
      const isMenuOpen = header.classList.contains("menu-open");
  
      if (!isMenuOpen) {
        menuButton.click();
  
        // Esperamos un poco después de abrir el menú
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            if (searchInput) {
              searchInput.focus();
              searchInput.scrollIntoView({ behavior: "smooth", block: "center" }); // Opcional: centrar input
            }
          });
        });
      } else {
        if (searchInput) {
          searchInput.focus();
          searchInput.scrollIntoView({ behavior: "smooth", block: "center" });
        }
      }
    });
  }
  
  modalClose.addEventListener("click", function () {
    if (suggestions) suggestions.style.display = "none";
  
    if (openedFrom === "menu") {
      // Si venimos del menú, mostramos el nav
      if (navBody) navBody.style.display = "block";
    } else if (openedFrom === "search") {
      // Si venimos desde la lupa, dejamos el nav oculto
      if (navBody) navBody.style.display = "none";
      if (suggestions) suggestions.style.display = "flex";
    }
  
  });
  // detecto caracteres en el input para mostrar la x
  if (searchInput) {
    searchInput.addEventListener("input", function () {
      if (searchInput.value.trim() !== "") {
        if (modalClose) modalClose.style.display = "block";
      } else {

        if(openedFrom == "search"){
          if (modalClose) modalClose.style.display = "none";
        }
        else{
          if (modalClose) modalClose.style.display = "none";
          if (suggestions) suggestions.style.display = "none"; // Ocultar sugerencias
      if (navBody) navBody.style.display = "block";
        }
        
      }
    });
    searchInput.addEventListener("focus", function () {
      if (navBody) navBody.style.display = "none";
      if (suggestions) suggestions.style.display = "flex";
    });
  }
  suggestionWords.forEach(suggestion => {
    suggestion.addEventListener("click", function () {
      let text = suggestion.textContent.trim();

      // Quitamos las comillas si existen
    text = text.replace(/^"(.*)"$/, "$1");


      if (searchInput) {
        searchInput.value = text;
  
        // Disparar manualmente el evento 'input' para mantener todo sincronizado
        searchInput.dispatchEvent(new Event('input'));
      }
    });
  });

  const pageMenuInner = document.querySelector("#page-menu .inner");

  if (pageMenuInner) {
    pageMenuInner.addEventListener("click", function (event) {
      const isClickInsideInput = searchInput && searchInput.contains(event.target);
      const isClickInsideSuggestions = suggestions && suggestions.contains(event.target);
  
      if (!isClickInsideInput && !isClickInsideSuggestions) {
        if (openedFrom === "search") {
          // Si vinimos desde la búsqueda
  
          if (modalClose) modalClose.click();
          
          // 👇 Volver a mostrar el menú desktop
          if (menuDesktopOrder) {
            
            menuDesktopOrder.classList.add("no-hover-temporal");
            setTimeout(() => {
              menuDesktopOrder.classList.remove("no-hover-temporal");
            }, 2000); // medio segundo aprox
            menuDesktopOrder.style.visibility = "visible";
            if (navLeftMenu) navLeftMenu.style.display = "none";
            menuButton.click();
          }
  
          openedFrom = ""; // Reseteamos openedFrom
        } else {
          // Comportamiento normal si vinimos desde el menú
          if (navBody) navBody.style.display = "block";
          if (suggestions) suggestions.style.display = "none";
  
          if (searchInput && searchInput.value.trim() !== "") {
            if (modalClose) modalClose.click();
          }
        }
      }
    });
  }
  // Detectar click en el botón de menú
  menuButton.addEventListener("click", function () {
    if (openedFrom === "") {
      openedFrom = "menu"; // Solo ponemos "menu" si no venimos de la lupa
    }
    const isMenuOpen = header.classList.toggle("menu-open"); // Alternar clase

    if (isMenuOpen) {
      applyStyles();
    } else {
      resetStyles();

      if (openedFrom === "search" && openedFromBuscadorDesktop) {
        if (navLeftMenu) navLeftMenu.style.display = "none"; // Mostrar nav-left--menu
        menuDesktopOrder.classList.add("no-hover-temporal");
        setTimeout(() => {
          menuDesktopOrder.classList.remove("no-hover-temporal");
        }, 2000);
        if (menuDesktopOrder) menuDesktopOrder.style.visibility = "visible"; // Mostrar MenuDesktop__Order
        
      }
  
      // 🔥 Limpieza de variables SIEMPRE después
      openedFrom = "";
      openedFromBuscadorDesktop = false;
    }
      
    
    // ➡️ NUEVA LÓGICA: Si el input tiene valor o las suggestions están visibles, hacer click en modalClose
    const hasInputValue = searchInput && searchInput.value.trim() !== "";
    const isSuggestionsVisible = suggestions && suggestions.style.display !== "none" && suggestions.style.display !== "";

    if ((hasInputValue || isSuggestionsVisible) && modalClose) {
      modalClose.click();
    }
  
  });

  // También verificamos si el usuario hace scroll para actualizar estilos dinámicamente
  window.addEventListener("scroll", resetStyles);

  // // Cerrar el menu al redimensionar la ventana al tamaño de escritorio
  // window.addEventListener("resize", function () {
  //   const mobileBreakpoint = 767;

  //   if (
  //     window.innerWidth > mobileBreakpoint &&
  //     header.classList.contains("menu-open")
  //   ) {
  //     // Simular click en el botón de menú para ejecutar toda su lógica
  //     menuButton.click();

  //     // Reset adicional para asegurar estado limpio
  //     resetStyles();
  //   }
  // });

});